import { render, staticRenderFns } from "./AppWhoNotify.vue?vue&type=template&id=6f7ad1d4&scoped=true&"
import script from "./AppWhoNotify.vue?vue&type=script&lang=js&"
export * from "./AppWhoNotify.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AppWhoNotify.vue?vue&type=style&index=0&id=6f7ad1d4&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6f7ad1d4",
  null
  ,true
)

export default component.exports